module.exports = __webpack_public_path__ + "static/media/oferteo.5041d246.png";